import {Injectable} from '@angular/core';
import {WindowReferenceService} from "./window-reference.service";

// declare let gtag: Function;
declare var gtag

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {

    private window;

    constructor(private _windowRef: WindowReferenceService) {
        this.window = _windowRef.nativeWindow;
    }

    private assignGtagObj(obj) {
        if (obj) this.window.dataLayer.push(obj);
    }


    public productDetailsViewed(sku, name, price, categoryname, currency) {

        this.window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        this.window.dataLayer.push({
            event: "view_item",
            ecommerce: {
                currency: currency,
                value: price,
                items: [
                    {
                        item_id: sku,
                        item_name: name,
                        affiliation: "",
                        coupon: "",
                        discount: 0,
                        index: 0,
                        item_category: categoryname,
                        location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
                        price: price,
                        quantity: 1
                    }
                ]
            }
        });

    }


    public productAddedToWishlist(sku, name, price, categoryname, currency) {

        this.window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        this.window.dataLayer.push({
            event: "add_to_wishlist",
            ecommerce: {
                currency: currency,
                value: price,
                items: [
                    {
                        item_id: sku,
                        item_name: name,
                        affiliation: "",
                        coupon: "",
                        discount: 0,
                        index: 0,
                        item_category: categoryname,
                        location_id: "ChIJIQBpAG2ahYAR_6128GcTUEo",
                        price: price,
                        quantity: 1
                    }
                ]
            }
        });

    }

    public purchase(transaction_id, total, products) {

        this.window.dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.
        this.window.dataLayer.push({
                'event': 'purchase',
                'transactionId': transaction_id,
                'transactionTotal': total,
                'transactionProducts': products
            }
        );

    }

    public eventEmitter(eventName: string, eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null) {
        gtag('event', eventName, {
            'event_category': eventCategory,
            'event_label': eventLabel,
            'value': eventValue
        })
    }


}
